import { render, staticRenderFns } from "./index.vue?vue&type=template&id=05e7aacb"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AdvBanner: require('/app/app/components/adv/Banner/index.vue').default,AuthorCarousel: require('/app/app/components/author/Carousel/index.vue').default})
